<script lang="ts">
  import type { Snippet } from "svelte";

  let { children, anchorLeftPosition, position } = $props<{
    children?: Snippet;
    anchorLeftPosition?: string | false;
    position?: "top" | "bottom";
  }>();
</script>

<div class="bubble" data-position={position}>
  <div class="body">
    {@render children?.()}
  </div>
  {#if anchorLeftPosition !== false}
    <span class="arrow" style={`left: ${anchorLeftPosition || "50%"}`}></span>
  {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  :global {
    $seamFixHeight: 1px;

    .bubble {
      overflow: hidden;
      pointer-events: none;
      margin-bottom: var(--bubble-vertical-offset);
      margin-top: var(--bubble-vertical-offset);

      --bubble-vertical-offset: calc(var(--bubble-context-spacing) + var(--bubble-arrow-height));
      .body {
        filter: tokens.$oc-semantic-shadow-above;
        overflow: hidden;
        pointer-events: all;
      }
      .body {
        background-color: var(--bubble-background-color);
        padding: var(--bubble-padding);
        color: var(--bubble-copy-color);
        border-radius: var(--bubble-border-radius);
        font: var(--bubble-copy-font);
      }
      .arrow {
        width: calc(var(--bubble-arrow-width) + $seamFixHeight * 2);
        height: calc(var(--bubble-arrow-height) + $seamFixHeight);
        margin-top: $seamFixHeight;
        background-color: var(--bubble-background-color);
        clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
        transform-origin: center;
        position: absolute;
        bottom: var(--bubble-context-spacing);
        left: 50%;
        transform: translate(-50%, 0%) rotate(180deg);
        z-index: 9999;
      }
      &[data-position="bottom"] {
        margin-bottom: 0;

        .arrow {
          bottom: auto;
          top: var(--bubble-vertical-offset);
          transform: translate(-50%, -100%);
        }
      }
      &[data-position="top"] {
        margin-top: 0;
      }
    }
  }
</style>
